const internationalization = {
  "locales": [
    "en",
    "th"
  ],
  "requiredLocales": [
    "en",
    "th"
  ],
  "strictMode": "inclusive",
  "defaultLocale": "en"
};
const dictionary = {
  "fill": true,
  "contentAutoTransformation": false,
  "location": "hybrid",
  "importMode": "fetch"
};
const routing = {
  "mode": "no-prefix",
  "storage": {
    "cookies": [
      {
        "name": "INTLAYER_LOCALE",
        "attributes": {
          "path": "/"
        }
      }
    ],
    "headers": [
      {
        "name": "x-intlayer-locale"
      }
    ]
  },
  "basePath": ""
};
const content = {
  "fileExtensions": [
    ".content.ts",
    ".content.js",
    ".content.cjs",
    ".content.mjs",
    ".content.json",
    ".content.json5",
    ".content.jsonc",
    ".content.tsx",
    ".content.jsx",
    ".content.md",
    ".content.mdx",
    ".content.yaml",
    ".content.yml"
  ],
  "contentDir": [
    "/vercel/path0/apps/web"
  ],
  "codeDir": [
    "/vercel/path0/apps/web"
  ],
  "excludedPath": [
    "**/node_modules/**",
    "**/dist/**",
    "**/build/**",
    "**/.intlayer/**",
    "**/.next/**",
    "**/.nuxt/**",
    "**/.expo/**",
    "**/.vercel/**",
    "**/.turbo/**",
    "**/.tanstack/**",
    "**/.output/**",
    "**/.svelte-kit/**"
  ],
  "watch": true
};
const system = {
  "baseDir": "/vercel/path0/apps/web",
  "moduleAugmentationDir": "/vercel/path0/apps/web/.intlayer/types",
  "unmergedDictionariesDir": "/vercel/path0/apps/web/.intlayer/unmerged_dictionary",
  "remoteDictionariesDir": "/vercel/path0/apps/web/.intlayer/remote_dictionary",
  "dictionariesDir": "/vercel/path0/apps/web/.intlayer/dictionary",
  "dynamicDictionariesDir": "/vercel/path0/apps/web/.intlayer/dynamic_dictionary",
  "fetchDictionariesDir": "/vercel/path0/apps/web/.intlayer/fetch_dictionary",
  "typesDir": "/vercel/path0/apps/web/.intlayer/types",
  "mainDir": "/vercel/path0/apps/web/.intlayer/main",
  "configDir": "/vercel/path0/apps/web/.intlayer/config",
  "cacheDir": "/vercel/path0/apps/web/.intlayer/cache",
  "tempDir": "/vercel/path0/apps/web/.intlayer/tmp"
};
const editor = {
  "applicationURL": "https://somemath.com",
  "editorURL": "http://localhost:8000",
  "cmsURL": "https://app.intlayer.org",
  "backendURL": "https://back.intlayer.org",
  "port": 8000,
  "enabled": false,
  "clientId": "551cb80164d0766282910824fcfb56d6",
  "dictionaryPriorityStrategy": "local_first",
  "liveSync": false,
  "liveSyncPort": 4000,
  "liveSyncURL": "http://localhost:4000"
};
const analytics = {
  "enabled": false,
  "flushInterval": 20000,
  "sampleRate": 1
};
const log = {
  "mode": "default",
  "prefix": "\u001b[38;5;239m[intlayer] \u001b[0m"
};
const ai = {};
const build = {
  "mode": "auto",
  "minify": false,
  "purge": false,
  "chunkGrouping": true,
  "dictionariesPreload": true,
  "traversePattern": [
    "**/*.{tsx,ts,js,mjs,cjs,jsx,vue,svelte,astro}",
    "!**/node_modules/**",
    "!**/dist/**",
    "!**/build/**",
    "!**/.intlayer/**",
    "!**/.next/**",
    "!**/.nuxt/**",
    "!**/.expo/**",
    "!**/.vercel/**",
    "!**/.turbo/**",
    "!**/.tanstack/**",
    "!**/.output/**",
    "!**/.svelte-kit/**",
    "!**/*.config.*",
    "!**/*.test.*",
    "!**/*.spec.*",
    "!**/*.stories.*",
    "!**/*.d.ts",
    "!**/*.d.ts.map",
    "!**/*.map"
  ],
  "outputFormat": [
    "esm",
    "cjs"
  ],
  "cache": true,
  "checkTypes": false
};
const compiler = {
  "enabled": false,
  "dictionaryKeyPrefix": "",
  "noMetadata": false,
  "saveComponents": false
};
const schemas = undefined;
const plugins = undefined;

export { internationalization, dictionary, routing, content, system, editor, analytics, log, ai, build, compiler, schemas, plugins };
